module.exports = __webpack_public_path__ + "img/4.80d3cc7b.png";